module.exports = __webpack_public_path__ + "assets/Deepbite.8471d2139165b0b74e3ea84768824757.png";